import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faInstagram, 
  faSnapchat, 
  faSnapchatGhost, 
  faTiktok, 
  faTwitter, 
  faYoutube 
} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-influencer-social-media-profile',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  templateUrl: './influencer-social-media-profile.component.html',
  styleUrls: ['./influencer-social-media-profile.component.scss']
})
export class InfluencerSocialMediaProfileComponent implements OnInit {
  @Input() influencer: any = {};

  faYoutube = faYoutube;
  faTwitter = faTwitter;
  faInstagram = faInstagram;
  faTiktok = faTiktok;
  faSnapchat = faSnapchatGhost;

  constructor() {}

  ngOnInit(): void {}


}
